import React from 'react';
import { withAnalyticsContext } from '@atlaskit/analytics-next';
import { Modal, ModalTransition } from '@atlaskit/onboarding';
import { Text } from '@atlaskit/primitives/compiled';
import { useIntl } from '@atlassian/jira-intl';
import {
	FireScreenAnalytics,
	fireUIAnalytics,
	useAnalyticsEvents,
} from '@atlassian/jira-product-analytics-bridge';
import welcomeImage from './assets/welcome.png';
import messages from './messages.tsx';

type Props = {
	isActive?: boolean;
	onStart: () => void;
	onCancel: () => void;
};

const WelcomeModal = ({ isActive = true, onStart, onCancel }: Props) => {
	const { createAnalyticsEvent } = useAnalyticsEvents();
	const { formatMessage } = useIntl();

	const handleCancel = () => {
		onCancel();

		const analyticsEvent = createAnalyticsEvent({
			action: 'clicked',
			actionSubject: 'exploreButton',
		});

		fireUIAnalytics(analyticsEvent);
	};

	const handleStart = () => {
		onStart();

		const analyticsEvent = createAnalyticsEvent({
			action: 'clicked',
			actionSubject: 'startButton',
		});

		fireUIAnalytics(analyticsEvent);
	};

	return (
		<ModalTransition>
			{isActive && (
				<>
					<Modal
						actions={[
							{
								onClick: handleCancel,
								text: formatMessage(messages.explore),
								appearance: 'subtle',
							},
							{
								onClick: handleStart,
								text: formatMessage(messages.tour),
								appearance: 'primary',
							},
						]}
						heading={formatMessage(messages.title)}
						image={welcomeImage}
						key="welcome"
					>
						<Text as="p">{formatMessage(messages.description)}</Text>
					</Modal>
					<FireScreenAnalytics />
				</>
			)}
		</ModalTransition>
	);
};

export default withAnalyticsContext({
	source: 'OpsDashboardWelcomeModal',
})(WelcomeModal);
